import maptunDefaults, { createPriceFormatter } from '../3togqybnuz-1/config.js';

export default {
  ...maptunDefaults,
  includes: ['bigcommerce-generic', '3togqybnuz-1'],
  product: {
    formatPrice: createPriceFormatter('en-US'),
  },
};
